import h from 'hyperscript';
import Dropdown from 'ui/dialog/dropdown';
import { default as i18n, defineNamespace } from 'cadenza/utils/i18n';
import messages from './messages_de.properties';

defineNamespace('like-condition-dropdown', messages);

export default class LikeConditionDropdown extends Dropdown {

  constructor (options = {}) {
    super();
    const {filterType} = options;
    this._createDialogContent(filterType);
  }

  close () {
    const filterType = this.dialog.querySelector('input[type="radio"]:checked').value;
    super.close(filterType);
  }

  _createDialogContent (filterType) {
    this.dialog.append(
      h('h1.d-dropdown-heading', i18n('like-condition-dropdown:filter.type.label')),
      ...['SUBSTRING', 'PREFIX', 'PATTERN'].map(type => createRadio(type, type === filterType)));

    function createRadio (type, checked) {
      return h('label.d-form-check', [
        h('input', {
          type: 'radio',
          name: 'filter-type',
          value: type,
          checked
        }),
        i18n(`like-condition-dropdown:filter.type.${type.toLowerCase()}`)
      ]);
    }
  }

}

customElements.define('d-like-condition-dropdown', LikeConditionDropdown);
